export default function () {
  this.route('proxyviews-directory', { path: '/providers' });
  this.route('proxyviews-compare', { path: '/providers/compare' });
  this.route('proxyviews-provider', {
    path: '/providers/:slug',
  });
  this.route('proxyviews-calculator', { path: '/calculator' });
  this.route('proxyviews-methodology', { path: '/methodology' });
  this.route('proxyviews-affiliate-disclosure', { path: '/affiliate-disclosure' });

  // Extend the adminPlugins route to include our dashboard
  this.route('adminPlugins', { path: '/admin/plugins' }, function () {
    this.route('proxyviews-directory', { path: '/proxyviews-directory' });
  });

  this.route('proxyviews-vendor-dashboard', { path: '/vendor/proxyviews-directory/providers/:slug' });
}
